// directives/css.ts
import { noChange } from "lit";
import { Directive, directive, PartType } from "lit/directive.js";
import { styleMap } from "lit/directives/style-map.js";
var StyleDirective = class extends Directive {
  constructor(partInfo) {
    super(partInfo);
    if (partInfo.type !== PartType.ELEMENT)
      throw new Error("css can only be used as ElementPart");
    if (!(partInfo.element instanceof HTMLElement))
      throw new Error("css can only be used on HTMLElement");
  }
  update(part, [styleInfo]) {
    const style = styleMap({})["_$litDirective$"].prototype.render(styleInfo);
    part.element.setAttribute("style", style);
    return this.render(style);
  }
  render(style) {
    return noChange;
  }
};
var css = directive(StyleDirective);
export {
  StyleDirective,
  css
};
